module.exports = __webpack_public_path__ + "img/forgot-password-svg.584bcf8c.svg";